import FormBuilderController from '~/pages/form-builder/form-builder.controller';
import templateKformBuilderParametersModal from '../modal/parameters/modal-kform-builder-parameters.html';
import ModalKformBuilderParametersController from '../modal/parameters/modal-kform-builder-parameters.controller';
import templateKformBuilderMacrosModal from '../modal/macros/modal-kform-builder-macros.html';
import ModalKformBuilderMacrosController from '../modal/macros/modal-kform-builder-macros.controller';

import templateKformBuilderScriptModal from '../modal/script/modal-kform-builder-script.html';
import ModalKformBuilderScriptController from '../modal/script/modal-kform-builder-script.controller';

export default class KformBuilderToolbarController {
	/* @ngInject */
	/**
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor(FormService, $uibModal) {
		this.FormService = FormService;
		this.$uibModal = $uibModal;

		/** @type {?FormBuilderController} */
		this.ctrl = null;
	}

	async openMacrosModal() {
		this.ctrl?.form?.updateMap();

		const newScript = await this.$uibModal.open({
			ariaLabelledBy:  'modal-kform-builder-macros-title',
			ariaDescribedBy: 'modal-kform-builder-macros-body',
			template:        templateKformBuilderMacrosModal,
			controller:      ModalKformBuilderMacrosController,

			controllerAs:    '$ctrl',
			resolve: {
				components: () => this.ctrl?.form?.map,
				script: () => this.ctrl?.form?.script,
			},
			size:            'lg',
			backdrop:        'static',
		}).result;

		if (this.ctrl?.form && newScript) {
			this.ctrl.form.script = newScript;
			this.ctrl.modified = true;
		}
	}

	async openParametersModal() {
		const parameters = await this.$uibModal.open({
			ariaLabelledBy:  'modal-kform-builder-parameters-title',
			ariaDescribedBy: 'modal-kform-builder-parameters-body',
			template:        templateKformBuilderParametersModal,
			controller:      ModalKformBuilderParametersController,
			controllerAs:    '$ctrl',
			resolve:         {
				parameters: () => this.ctrl?.form?.params,
			},
		}).result;

		if (this.ctrl?.form && parameters) {
			this.ctrl.form.params = parameters;
			this.ctrl.modified = true;
		}
	}

	async openScriptModal() {
		const script = await this.$uibModal.open({
			ariaLabelledBy:  'modal-kform-builder-script-title',
			ariaDescribedBy: 'modal-kform-builder-script-body',
			template:        templateKformBuilderScriptModal,
			controller:      ModalKformBuilderScriptController,

			controllerAs:    '$ctrl',
			size:            'lg',
			backdrop:        'static',
			windowClass:     'kform-builder-script-modal',
			resolve:         {
				script: () => this.ctrl?.form?.script,
			},
		}).result;

		if (this.ctrl?.form && script !== undefined) {
			this.ctrl.form.script = script;
			this.ctrl.modified = true;
		}
	}
}
